import { Blob, DocumentType } from '@consigli/types';

export function parseBlobResults(results: Array<Blob>) {
  return results
    .filter((blob) => blob.extension?.toLowerCase().replace(/^\./, '') !== 'md')
    .map((blob) => ({
      id: blob.id,
      name: blob.name,
      extension: blob.extension,
      fileUrl: blob.fileUrl,
      downloadUrl: blob.downloadUrl,
      type: DocumentType.BLOB as const,
      documentPackageId: blob.documentPackage,
      ns3451: blob.ns3451 || [],
      parsedData: blob.parsedData || {},
      convertedPdfFileId: blob.convertedPdfFileId,
      ...(blob.metadata && { metadata: blob.metadata }),
    }));
}
